import type { HarmonyPackageDocument } from '@rhythmic/db/types'
import type { UseLiveQueryReturn } from '@tanstack/vue-db'
import { useLiveQuery } from '@tanstack/vue-db'
import { getHarmonyDocumentCollection } from '../contexts'

export function useDocumentsByHarmonyPlanId(
  planId: string | null | undefined,
): UseLiveQueryReturn<HarmonyPackageDocument> | undefined {
  if (!planId) {
    return undefined
  }

  const collection = getHarmonyDocumentCollection(planId)
  const query = useLiveQuery((q) => q.from({ t: collection }).orderBy(({ t }) => (t as any).createdAt ?? '', 'desc'))

  return query
}
